var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoaddark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z",
    fill: "#E5E9EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2773_62454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6698 24.1701L22.3698 18.8701H21.3798L18.8398 21.4101V22.4001L24.1398 27.7001C24.5298 28.0901 25.1598 28.0901 25.5498 27.7001L27.6698 25.5801C28.0598 25.2001 28.0598 24.5601 27.6698 24.1701ZM24.8398 25.5901L20.5998 21.3501L21.3098 20.6401L25.5498 24.8801L24.8398 25.5901Z",
    fill: "#1A2024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.34 16.19L24.75 14.78L26.87 16.9C28.04 15.73 28.04 13.83 26.87 12.66L23.33 9.12L21.92 10.53V7.71L21.22 7L17.68 10.54L18.39 11.25H21.22L19.81 12.66L20.87 13.72L17.98 16.61L13.85 12.48V11.06L10.83 8.04L8 10.87L11.03 13.9H12.44L16.57 18.03L15.72 18.88H13.6L8.3 24.18C7.91 24.57 7.91 25.2 8.3 25.59L10.42 27.71C10.81 28.1 11.44 28.1 11.83 27.71L17.13 22.41V20.29L22.28 15.14L23.34 16.19ZM15.36 21.34L11.12 25.58L10.41 24.87L14.65 20.63L15.36 21.34Z",
    fill: "#1A2024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2773_62454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoaddark);
export default __webpack_public_path__ + "static/media/Roaddark.4f4ece21a54aeeb20f4b98b30e668ba8.svg";
export { ForwardRef as ReactComponent };